.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  height: var(--control-height);
  padding: 0 var(--space-4);
  border: 0;
  border-radius: var(--radius-control);
  font: var(--text-subhead);
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
}

.withIcon {
  padding-inline-start: var(--space-2);
}

.icon {
  margin-block: calc(-1 * var(--space-1));
}

.primario {
  background: var(--ink);
  color: var(--on-ink);
}

.primario:hover:not(:disabled) {
  background: color-mix(in srgb, var(--ink) 84%, var(--card));
}

.secundario {
  background: var(--fill);
  color: var(--label);
}

.secundario:hover:not(:disabled) {
  background: color-mix(in srgb, var(--fill) 80%, var(--ink));
}

.button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-top: var(--space-1);
}

@media (max-width: 719px) {
  .row > * {
    flex: 1;
  }

  .row > :first-child {
    flex: 2;
  }
}

@media (pointer: coarse) {
  .button {
    height: auto;
    min-height: var(--control-height-coarse);
  }
}
